export default "__VITE_ASSET__DFnLMvY9__"